module.exports = __webpack_public_path__ + "static/media/user.ac642e61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/user.svg
// module id = 214
// module chunks = 2